import React from 'react';
import Hero from '../components/Hero';
import WhyUs from '../components/WhyUs';
import Steps from '../components/Steps';
import Products from '../components/Products';
import Testimonials from '../components/Testimonials';
import Footer from '../components/Footer';
import InsurancePartners from '../components/InsurancePartners';


const HomePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
      <Hero />
      <WhyUs />
      <Steps />
      <Products />
      <InsurancePartners />
      <Testimonials />
      <Footer />
    </div>
  );
};

export default HomePage;